import React, { useState, useEffect} from 'react';
import "./NewGamesArea.css";
import {Link} from 'react-router-dom';
import Slider from 'react-slick';


import svg1 from '../../../images/Web3 Social Network E2E.svg';
import svg2 from '../../../images/Cipherem Chain Ecosystem.svg';
import svg3 from '../../../images/NFT Marketplace.svg';
import svg4 from '../../../images/Cipherem Decentralised Finance.svg';
import svg5 from '../../../images/E2E Metaverse.svg';


import svg_1 from '../../../images/mpt1.png';
import svg_2 from '../../../images/mpt4.png';
import svg_3 from '../../../images/mpt2.png';
import svg_4 from '../../../images/mpt5.png';
import svg_5 from '../../../images/mpt3.png';



function NewGamesArea() {
 
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let slider1,slider2;


  


  useEffect(function(){
    setNav1(slider1)
    setNav2(slider2)
    
  },[slider1,slider2])
   
  console.log(nav1);
  console.log(nav2);
  return (
  
	<section className="donation-area donation-bg fix pt-65 pb-105">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="third-section-title text-center mb-0 ">
                    <h2 style={{fontFamily: "'Oxanium', cursive"}}>META <span>PORTALS</span></h2>
                  </div>
                </div>
              </div>

              
              <div className="row align-items-center">
              <div className="col-xl-4 col-lg-12" id = "s2">
                  <Slider className="" 
                  asNavFor={nav1}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  ref={slider => (slider2 = slider)} slidesToShow={3} vertical={true} arrows={false} >
                    <div className="released-game-nav-item web3">
                      <img src={svg1} alt="" />
                      <h5>Web3 Social Network</h5>
                    </div>
                    <div className="released-game-nav-item chain">
                      <img src={svg2} alt="" />
                      <h5>Cipherem Chain Ecosystem</h5>
                    </div>
                    <div className="released-game-nav-item nft">
                      <img src={svg3} alt="" />
                      <h5>Cipherem NFT marketplace</h5>
                    </div>
                    <div className="released-game-nav-item finance">
                      <img src={svg4} alt="" />
                      <h5>Cipherem Decentralised Finance</h5>
                    </div>
                    <div className="released-game-nav-item e2e">
                      <img src={svg5} alt="" />
                      <h5>Cipherem E2E Metaverse</h5>
                    </div>
                  </Slider>
                </div>
                <div className="col-xl-8 col-lg-12">
                  <Slider className="released-game-active"
                  asNavFor={nav2}
                  style = {{'height': '100%'}}
                  ref={slider => (slider1 = slider)}
                  arrows={false}
                  >


                    {/* ************** */}
                    <div className="released-game-carousel">
                      <div className="released-game-item" style={{'height': '100%', 'minHeight': '24rem'}}>
                        <div className="released-game-item-bg"  />
                        <div className="released-game-img">
                          <img src={svg1} alt="" style={{'width': '100%'}}/>
                        </div>
                        <div className="released-game-content" style={{'margin-top': '2rem', 'margin-right': '1rem', 'margin-bottom': '1rem', 'width': '100%'}}>
                          <h3>Web3 Social Network </h3>
                          <p>Cipherem aims to turn ‘likes' a commonality on traditional social media into Cipherem cryptocurrencies through its underlying technology. Users can have bold new ways to earn online and so much more from sharing content on the platform and other activities like voting, commenting, liking or giving trinkets virtually that would play a part in Cipherem Metaverse, Web3 App V1 eco-system as part of our Engage 2 Earn initiative. </p>
                          <Link to="/register" className="btn btn-style-two" style={{'margin-right': '2rem'}}>Sign up for free</Link>
                          <Link to="/login" className="btn btn-style-two">Login</Link>
                        </div>
                      </div>
                    </div>
                    {/* ******************* */}


                    {/* ************** */}
                    <div className="released-game-carousel">
                      <div className="released-game-item" style={{'height': '100%', 'minHeight': '24rem'}}>
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src={svg2} alt="" style={{'width': '100%'}}/>
                        </div>
                        <div className="released-game-content" style={{'margin-top': '2rem', 'margin-bottom': '1rem', 'width': '100%'}}>
                          <h3>Cipherem Chain Ecosystem</h3>
                          <p>
                            We built it the way our community likes it. Users will have control over their data, rights and ownership to enhance digital identity and end user confidence. 
                            With lower emissions, faster and cheaper transaction speed! Cipherem is a technology that’s home to builders, it's open to everyone, wherever you are – all you need is the internet. 
                          </p>
                          <Link to="/register" className="btn btn-style-two" style={{'margin-right': '2rem'}}>Sign up for free</Link>
                          <Link to="/login" className="btn btn-style-two">Login</Link>
                        </div>
                      </div>
                    </div>
                    {/* ******************* */}

                    {/* ************** */}
                    <div className="released-game-carousel">
                      <div className="released-game-item" style={{'height': '100%', 'minHeight': '24rem'}}>
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src={svg3} alt="" style={{'width': '100%'}}/>
                        </div>
                        <div className="released-game-content" style={{'margin-top': '2rem', 'margin-bottom': '1rem', 'width': '100%'}}>
                          <h3>Cipherem NFT Marketplace </h3>
                          <p>Create, Buy & Sell NFTs on our marketplace. Arts, Videos, Music, Tweets, you name it! Start creating and earning in this fun marketplace built for creators. </p>
                          <Link to="/register" className="btn btn-style-two" style={{'margin-right': '2rem'}}>Sign up for free</Link>
                          <Link to="/login" className="btn btn-style-two">Login</Link>
                        </div>
                      </div>
                    </div>
                    {/* ******************* */}

                    {/* ************** */}
                    <div className="released-game-carousel">
                      <div className="released-game-item" style={{'height': '100%', 'minHeight': '24rem'}}>
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src={svg4} alt="" style={{'width': '100%'}}/>
                        </div>
                        <div className="released-game-content" style={{'margin-top': '2rem', 'margin-bottom': '1rem', 'width': '100%'}}>
                          <h3>Cipherem Decentralised Finance </h3>
                          <p>An Open system that gives you the freedom of direct access to your assets. A better future that built a new, internet-native financial system, using blockchains to replace traditional intermediaries and trust mechanisms.</p>
                          <Link to="/register" className="btn btn-style-two" style={{'margin-right': '2rem'}}>Sign up for free</Link>
                          <Link to="/login" className="btn btn-style-two">Login</Link>
                        </div>
                      </div>
                    </div>
                    {/* ******************* */}

                    {/* ************** */}
                    <div className="released-game-carousel">
                      <div className="released-game-item" style={{'height': '100%', 'minHeight': '24rem'}}>
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src={svg5} alt="" style={{'width': '100%'}}/>
                        </div>
                        <div className="released-game-content" style={{'margin-top': '2rem', 'margin-bottom': '1rem', 'width': '100%'}}>
                          <h3>Cipherem E2E Metaverse</h3>
                          <p>Expect a different world, virtual experiences and communities, you'll never run out of places to explore and people to meet. Music, clubs, exhibitions, build your own server, walk freely in your custom avatar and invite your friends to join you in the metaverse.</p>
                          <Link to="/register" className="btn btn-style-two" style={{'margin-right': '2rem'}}>Sign up for free</Link>
                          <Link to="/login" className="btn btn-style-two">Login</Link>
                        </div>
                      </div>
                    </div>
                    {/* ******************* */}


                   



                    {/* <div className="released-game-carousel">
                      <div className="released-game-item">
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src="assets/img/images/released_game_img02.jpg" alt="" />
                        </div>
                        <div className="released-game-content">
                          <div className="released-game-rating">
                            <h5>Rating :</h5>
                            <div className="released-rating">
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                            </div>
                          </div>
                          <h4>Battle <span>Grounds</span></h4>
                          <div className="released-game-list mb-15">
                            <ul>
                              <li><span>Category :</span>Virtual Game</li>
                              <li><span>Model :</span>Compete 100 players</li>
                              <li><span>Controller :</span>Playstation 5 , Xbox , PS4</li>
                            </ul>
                          </div>
                          <p>Compete with 100 players on a remote thats island for winner takes showdown known issue</p>
                          <Link to="/#" className="btn btn-style-two">buy now</Link>
                        </div>
                      </div>
                    </div>
                    <div className="released-game-carousel">
                      <div className="released-game-item">
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src="assets/img/images/released_game_img03.jpg" alt="" />
                        </div>
                        <div className="released-game-content">
                          <div className="released-game-rating">
                            <h5>Rating :</h5>
                            <div className="released-rating">
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                            </div>
                          </div>
                          <h4>Apex <span>Legends</span></h4>
                          <div className="released-game-list mb-15">
                            <ul>
                              <li><span>Category :</span>Virtual Game</li>
                              <li><span>Model :</span>Compete 100 players</li>
                              <li><span>Controller :</span>Playstation 5 , Xbox , PS4</li>
                            </ul>
                          </div>
                          <p>Compete with 100 players on a remote thats island for winner takes showdown known issue</p>
                          <Link to="/#" className="btn btn-style-two">buy now</Link>
                        </div>
                      </div>
                    </div>
                    <div className="released-game-carousel">
                      <div className="released-game-item">
                        <div className="released-game-item-bg" />
                        <div className="released-game-img">
                          <img src="assets/img/images/released_game_img03.jpg" alt="" />
                        </div>
                        <div className="released-game-content">
                          <div className="released-game-rating">
                            <h5>Rating :</h5>
                            <div className="released-rating">
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                              <i className="fas fa-star" />
                            </div>
                          </div>
                          <h4>Monster <span>Hunter</span></h4>
                          <div className="released-game-list mb-15">
                            <ul>
                              <li><span>Category :</span>Virtual Game</li>
                              <li><span>Model :</span>Compete 100 players</li>
                              <li><span>Controller :</span>Playstation 5 , Xbox , PS4</li>
                            </ul>
                          </div>
                          <p>Compete with 100 players on a remote thats island for winner takes showdown known issue</p>
                          <Link to="/#" className="btn btn-style-two">buy now</Link>
                        </div>
                      </div>
                    </div> */}
                  </Slider>
                </div>
                
              </div>
            </div>
          </section>
  )
}

export default NewGamesArea